import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { http, formatApiError } from "@/lib/api";
import { APPT_STATUS, formatDateTime, maskConta, maskPhone } from "@/lib/format";
import { Panel, Info } from "@/components/admin/PageBits";

export const AppointmentStatusSelect = ({ appt, onChanged, testId }) => {
  const change = async (status) => {
    try {
      await http.patch(`/admin/appointments/${appt.id}/status`, { status });
      toast.success(`Status alterado para ${APPT_STATUS[status].label}.`);
      onChanged?.();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  return (
    <Select value={appt.status} onValueChange={change}>
      <SelectTrigger className="h-9 w-[190px] border-white/10 bg-black/30 text-sm text-slate-100" data-testid={testId}><SelectValue /></SelectTrigger>
      <SelectContent className="border-white/10 bg-[#141C2E] text-slate-100">
        {Object.entries(APPT_STATUS).map(([k, v]) => <SelectItem key={k} value={k} data-testid={`${testId}-option-${k}`}>{v.label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
};

export const AppointmentPanel = ({ appt, onChanged }) => (
  <Panel title="Agendamento" testId="appointment-panel" action={<AppointmentStatusSelect appt={appt} onChanged={onChanged} testId="detail-appt-status" />}>
    <div className="grid grid-cols-2 gap-4">
      <Info label="Responsável" value={appt.nome} testId="detail-appt-nome" />
      <Info label="Telefone" value={maskPhone(appt.telefone)} mono testId="detail-appt-telefone" />
      <Info label="Melhor horário" value={appt.horario_label} testId="detail-appt-horario" />
      <Info label="Agência" value={appt.agencia} mono testId="detail-appt-agencia" />
      <Info label="Conta" value={appt.conta ? maskConta(appt.conta) : "—"} mono testId="detail-appt-conta" />
      <Info label="Solicitado em" value={formatDateTime(appt.created_at)} />
      <Info label="Consentimento LGPD" value={formatDateTime(appt.consent_at)} />
    </div>
  </Panel>
);
